import React, {useState, useEffect} from "react";
import "./style.css";
import {CREATING_PLAIN_COMMENT} from "../../../../../const/WeightLossQuestionnaire";
import {Percentage} from "../Percentage/Percentage";
import {calculatePersonalizedCalories} from "../../../../../utils/calorieCalculator";

import { Image } from "../../../../../components/Image";
export const PcCreatingPlan = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage,
                                 percentageList,
                                 nextPercentage,
                                 data }) => {
  const [calculatedData, setCalculatedData] = useState(() => {
    const result = calculatePersonalizedCalories(data);
    return {
      profile: result.profile,
      calories: result.targetCalories,
      dietaryPreference: result.dietaryPreference
    };
  });

  useEffect(() => {
    if (data) {
      const result = calculatePersonalizedCalories(data);
      setCalculatedData({
        profile: result.profile,
        calories: result.targetCalories,
        dietaryPreference: result.dietaryPreference
      });
    }
  }, [data]);
  return (
    <div className="creating-plan-pc" data-model-id="16867:12412">

      <div className="contents">
        <div className="title">
          <div className="heading">Creating your personalized plan...</div>
        </div>

        <div className="div">
          <div className="frame-2">
            <div className="element">
              <div className="date">
                <div 
                  className="profile-label"
                  style={{
                    color: (percentageList[0]?.start && !percentageList[1]?.start)
                      ? 'var(--material-themesyslighton-surface)' 
                      : 'var(--material-themesyslightoutline)'
                  }}
                >
                  Analyzing profile:
                </div>

                {percentageList[0]?.start && (
                  <div 
                    className="profile-data"
                    style={{
                      color: (percentageList[0]?.start && !percentageList[1]?.start)
                        ? 'var(--material-themesyslighton-surface)'
                        : 'var(--material-themesyslightoutline)',
                      fontWeight: (percentageList[0]?.start && !percentageList[1]?.start) ? 700 : 500
                    }}
                  >
                    {calculatedData.profile}
                  </div>
                )}
              </div>


              <Percentage start={percentageList[0]?.start} successBack={nextPercentage} />
            </div>

            <div className="element">
              <div className="date">
                <div 
                  className="text-wrapper"
                  style={{
                    color: (percentageList[1]?.start && !percentageList[2]?.start)
                      ? 'var(--material-themesyslighton-surface)' 
                      : 'var(--material-themesyslightoutline)',
                    fontWeight: (percentageList[1]?.start && !percentageList[2]?.start) ? 700 : 500
                  }}
                >
                  Calculating metabolism:
                </div>

                {percentageList[1]?.start && (
                  <div 
                    className="text-wrapper"
                    style={{
                      color: (percentageList[1]?.start && !percentageList[2]?.start)
                        ? 'var(--material-themesyslighton-surface)'
                        : 'var(--material-themesyslightoutline)',
                      fontWeight: (percentageList[1]?.start && !percentageList[2]?.start) ? 700 : 500
                    }}
                  >
                    {calculatedData.calories} kcal
                  </div>
                )}
              </div>

              <Percentage start={percentageList[1]?.start} successBack={nextPercentage} />
            </div>

            <div className="element">
              <div className="date">
                <div 
                  className="text-wrapper"
                  style={{
                    color: percentageList[2]?.start 
                      ? 'var(--material-themesyslighton-surface)' 
                      : 'var(--material-themesyslightoutline)',
                    fontWeight: percentageList[2]?.start ? 700 : 500
                  }}
                >
                  Adjusting dietary preference:
                </div>

                {percentageList[2]?.start && (
                  <div 
                    className="text-wrapper"
                    style={{
                      color: 'var(--material-themesyslighton-surface)',
                      fontWeight: 700
                    }}
                  >
                    {calculatedData.dietaryPreference}
                  </div>
                )}
              </div>

              <Percentage start={percentageList[2]?.start} successBack={nextPercentage} />
            </div>
          </div>

          <div className="review-container">
            {CREATING_PLAIN_COMMENT?.map((item, index) => {
              return <div className="review-container-wrapper">
                <div className="review-container-2">
                  <Image src="/static/image/questionnaire/weight-loss/creating-plan/pc/star-rating-2.png" alt="Star rating" className="star-rating" />

                  <p className="review-text">
                    ”{item.content}“
                  </p>

                  <div className="reviewer-name">{item.name}</div>
                </div>
              </div>
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
